/* ============================================================
   HOSTED PLAYER (hosted.js) — Shopify-CDN native video
   ------------------------------------------------------------
   Plays MP4s hosted on the store's own CDN (cdn.shopify.com)
   with a plain <video> element. Same interface as VimeoPlayer /
   YouTubePlayer — play, pause, setMuted, seekToPercent, destroy,
   plus onTimeUpdate/onPlay/onPause callbacks — so feed.js treats
   all three identically.

   WHY THIS EXISTS
   Short-form clips are uploaded straight to Shopify Files via the
   Admin API (max 1 GB / 10 min / 4K per file; Shopify transcodes
   to 480p/720p/1080p + HLS automatically). This gives us:
   • no third-party embed, no iframe — full programmatic control
   • the store's own CDN doing the delivery
   • zero extra vendors (no Vimeo layer needed)

   CONTENT PIPELINE (run by KEM's AI)
   Drive folder → Admin API stagedUploadsCreate → fileCreate →
   CDN URLs land in the Feed Script sheet → sync_feed.py.

   SOURCE CHOICE: item.hostedSrc should be the 720p MP4 rendition
   (best mobile balance). item.hostedSrcHd (1080p) is swapped in on
   wide screens. The .m3u8 HLS rendition exists for a future
   hls.js/native-HLS upgrade — not needed for clips this short.
   ============================================================ */

class HostedPlayer {
  constructor(mount, item, callbacks = {}) {
    this.callbacks = callbacks;
    const wantHd = Math.min(window.innerWidth, window.innerHeight) > 800;
    const src = (wantHd && item.hostedSrcHd) || item.hostedSrc;

    this.video = document.createElement('video');
    this.video.src = src;
    if (item.hostedPoster) this.video.poster = item.hostedPoster;
    this.video.muted = true;            // mobile autoplay requires muted
    this.video.loop = true;
    this.video.playsInline = true;
    this.video.setAttribute('playsinline', '');
    this.video.preload = 'metadata';
    this.video.style.cssText =
      'width:100%;height:100%;object-fit:cover;display:block;background:#000';

    this.video.addEventListener('timeupdate', () => {
      const d = this.video.duration || 0;
      this.callbacks.onTimeUpdate?.({
        seconds: this.video.currentTime,
        percent: d ? this.video.currentTime / d : 0,
        duration: d,
      });
    });
    this.video.addEventListener('play',  () => this.callbacks.onPlay?.());
    this.video.addEventListener('pause', () => this.callbacks.onPause?.());

    mount.appendChild(this.video);
  }

  play()           { this.video.play().catch(() => {}); }
  pause()          { this.video.pause(); }
  setMuted(m)      { this.video.muted = m; }
  seekToPercent(p) {
    if (this.video.duration) this.video.currentTime = p * this.video.duration;
  }
  destroy() {
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.load();
    this.video.remove();
  }
}
